import React from 'react';
import styled from 'styled-components';
import useTracking from '../Tracking/useTracking';

const SitesLogoListWrapper = styled.div`
    ${p => p.backgroundGradient ? `background: ${p.backgroundGradient};` : ''}
    background-color:  ${p => p.backgroundColor};
    @media (max-width: 995px){
        font-size: 17px;
    }
`;

const SectionWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    height: 100%;
    padding: 70px 100px;
    max-width: 1920px;
    margin: 0 auto;

    @media (max-width: 995px) {
        padding: 70px 25px;
        flex-direction: column;
    }

    @media (max-width: 700px){
        padding: 30px 10px;
    }
`;

const SectionLeft = styled.div`
    width: 49%;
    padding-right: 20px;
    text-align: center;
    
    @media (max-width: 995px){
        padding: 0;
        width: 100%;
        justify-content: center;
        text-align: center;
    }

    @media (max-width: 700px) {
        justify-content: space-around;
        padding: 0 0 20px;
        margin-bottom: 15px;
    }
`;

const SectionRight = styled.div`
    width: 51%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    flex-direction: column;
    text-align: right;
    padding-left: 20px;
    
    @media (max-width: 995px){
        width: 100%;
        padding: 0;
        text-align: center;
    }
`;

const Logo = styled.img`
    width: 22%;
    display: inline-block;
    margin: 10px;
    padding: 10px;
     ${p => p.logoFilter ? `filter: ${p.logoFilter};` : ''}

    @media (max-width: 1630px) {
        width: 28%;
    }

    @media (max-width: 1300px) {
        width: 40%;
    }

    @media (max-width: 995px) {
        width: 20%;
        margin-bottom: 15px;
    }
    
    @media (max-width: 700px) {
        width: 45%;
        max-width: 100%!important;
        margin: 0 0 15px;
        padding: 13px;
    }
`;

const Title = styled.h2`
    font-size: 40px;
    margin-bottom: 19px;
    font-weight: 500;
    line-height: 1;
    text-transform: uppercase;
    color: ${p => p.titleColor};
    width: 100%;
    vertical-align: baseline;
    padding-left: 37%;

    @media (max-width: 1775px) {
        padding-left: 25%;
    }

    @media (max-width: 1535px) {
        padding-left: 20%;
    }

    @media (max-width: 1455px) {
        padding-left: 0;
    }

    @media (max-width: 995px) {
        letter-spacing: 1px;
    }
    
    @media (max-width: 700px) {
        margin: 0 0 15px;
        font-size: 7.8vw;
    }
`;

const Description = styled.p`
    color: ${p => p.descriptionColor};
    width: 100%;
    margin: 0;
    max-width: 660px;
    margin-left: auto;
    font-size: 22px;
    font-weight: 300;
    line-height: 1.4;
    margin-bottom: 25px;
    vertical-align: baseline;
    
    @media (max-width: 700px){
        font-size: 17px;
    }

    @media (max-width: 995px){
        text-align: center;
        margin-right: auto;
        max-width: none;
    }
`;

const Cta = styled.a`
    margin-top: 18px;
    width: 100%;
    margin-bottom: 19px;
    color: ${p => p.ctaColor};
    font-size: 20px;
    text-transform: uppercase;
    font-weight: 600;

    @media (max-width: 995px){
        margin-top: 10px;
        font-size: 125%;
        letter-spacing: 1px
    }

    @media (max-width: 700px){
        font-size: 22px;
        display: inline-block;
        line-height: 1.2;
    }
`;

const SitesLogoList = ({
    title = '',
    titleColor = '#FFF',
    description = '',
    descriptionColor = '#FFF',
    ctaText = '',
    ctaTitle = '',
    ctaLink,
    ctaColor = '#7E8FBB',
    logos = [],
    logoFilter,
    backgroundColor = '#000116',
    backgroundGradient = 'radial-gradient(ellipse at center, #070742 0, rgba(7, 7, 66, .98) 1%, rgba(7, 7, 66, 0) 50%, rgba(7, 7, 66, 0) 100%)',

}) => {

    const { trackAndRedirect } = useTracking();

    const handleClick = e => {
        e.stopPropagation();
        e.preventDefault();
        let payload = { component: 'SitesLogoList' };
        trackAndRedirect(payload, ctaLink);
    };



    return (
        <SitesLogoListWrapper backgroundColor={backgroundColor} backgroundGradient={backgroundGradient}>
            <SectionWrapper>
                <SectionLeft>
                    {logos.map((l, pos) => {
                        if (l.src) {
                            l.src = l.src.replace("images.ctfassets.net", "ctf-images.gammacdn.com");
                        }
                        return (<Logo src={l.src} alt={l.title} title={l.title} logoFilter={logoFilter} key={pos} />)
                    })}
                </SectionLeft>
                <SectionRight>
                    <Title dangerouslySetInnerHTML={{ __html: title }} titleColor={titleColor} />
                    <Description dangerouslySetInnerHTML={{ __html: description }} descriptionColor={descriptionColor} />
                    <Cta title={ctaTitle} href="#" ctaColor={ctaColor} onClick={handleClick}>{ctaText}</Cta>
                </SectionRight>
            </SectionWrapper>
        </SitesLogoListWrapper>
    );
};

export default SitesLogoList;
